import {
  Initialise,
  Teardown,
  ShowTopRating,
  ShowAllRating,
  ShowSpeedMap,
  ShowQuaddieTips,
} from '../states/signals'

import { ViewType, page$ } from '../states/page'
import { quaddie$ } from '../states/quaddie'
import {
  GiddyUpTabChanged,
  QuaddieValueChanged,
} from '@classic/AppUtils/Framework/Intent/giddyUpSignals'
import { track } from '@classic/Foundation/Analytics/Analytics'

interface ISelectedTab {
  currentView: string
}

let initaliseSignal: Rx.IDisposable
let tearDownSignal: Rx.IDisposable
let showTopRatingSignal: Rx.IDisposable
let showSpeedMapSignal: Rx.IDisposable
let showAllRatingSignal: Rx.IDisposable
let showQuaddieTipsSignal: Rx.IDisposable
let tabSelection: Rx.IDisposable
let valueSelection: Rx.IDisposable

export function trackGiddyUp() {
  initaliseSignal = Initialise.signal$.first().subscribe(() => trackSignal('open'))
  tearDownSignal = Teardown.signal$.first().subscribe(() => trackSignal('closed'))
  showTopRatingSignal = ShowTopRating.signal$
    .takeUntil(Teardown.signal$)
    .subscribe(s => trackSignal(s.name.toLowerCase()))
  showSpeedMapSignal = ShowSpeedMap.signal$
    .takeUntil(Teardown.signal$)
    .subscribe(s => trackSignal(s.name.toLowerCase()))
  showAllRatingSignal = ShowAllRating.signal$
    .takeUntil(Teardown.signal$)
    .subscribe(s => trackSignal(s.name.toLowerCase()))
  showQuaddieTipsSignal = ShowQuaddieTips.signal$
    .takeUntil(Teardown.signal$)
    .subscribe(s => trackSignal(s.name.toLowerCase()))

  tabSelection = page$
    .map<ISelectedTab>(x => {
      return {
        currentView: x ? ViewType[x.currentView] : ViewType[0],
      }
    })
    .distinctUntilChanged()
    .subscribe(record => {
      if (GiddyUpTabChanged) {
        GiddyUpTabChanged(record.currentView)
      }
    })

  valueSelection = quaddie$.distinctUntilChanged().subscribe(record => {
    if (QuaddieValueChanged) {
      QuaddieValueChanged(record.valueSelected)
    }
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function trackSignal(name: string, data?: any) {
  // TODO: Replace track function
  return track(`giddyup-${name}`, data)
}

export function disposeTrackGiddyUp() {
  initaliseSignal.dispose()
  tearDownSignal.dispose()
  showTopRatingSignal.dispose()
  showSpeedMapSignal.dispose()
  showAllRatingSignal.dispose()
  showQuaddieTipsSignal.dispose()
  tabSelection.dispose()
  valueSelection.dispose()
}
